/**
 * @packageDocumentation
 * Exports helper functions that apply shake and impact effects to PixiJS display objects using GSAP timelines.
 */
import gsap from "gsap";
import * as PIXI from "pixi.js";  
import { PortraitAdjustFun,landScapeAdjustFun } from "../app";

/**
 * Creates an electric shake animation effect on a PIXI Container or Sprite
 * @param target - The PIXI Container or Sprite to animate. Must have optional Tween property of type GSAPTimeline
 * @param intensity - The intensity of the shake effect. Default is 5
 * @param duration - The duration of the entire animation in seconds. Default is 0.1
 * @param repeatCount - Number of times to repeat the shake animation. Default is 5
 * @param actualX - The target's original X position
 * @param actualY - The target's original Y position
 * @returns GSAPTimeline - The GSAP timeline controlling the animation
 */
export function electricShake(target: (PIXI.Container|PIXI.Sprite)&{Tween?:GSAPTimeline}, intensity = 5, duration = 0.1, repeatCount = 5,actualX?:number,actualY?:number) {
// if(target.Tween){
//   target.Tween.kill()
// };
let timeOut:NodeJS.Timeout;
  const originalX = actualX!;
  const originalY = actualY!; 
 
  const timeline = gsap.timeline({
    repeat: repeatCount,
    yoyo: true,
    onComplete: () => {
      // Reset to original position
      // target.x = originalX;
      // target.y = originalY;
      clearTimeout(timeOut)
      timeOut = setTimeout(() => {
        if(window.matchMedia("(orientation:portrait)").matches){
          PortraitAdjustFun()
        }else{
          landScapeAdjustFun()
        } 
      }, duration / repeatCount);

    },
  }); 
  target.Tween = timeline;
  for (let i = 0; i < repeatCount; i++) {
    const offsetX = (Math.random() - 0.5) * 0.25 * intensity;
    const offsetY = (Math.random() - 0.5) * 0.25 * intensity;

    // console.log(offsetX)
    timeline.to(target, {
      x: originalX + offsetX,
      y: originalY + offsetY,
      duration: duration / repeatCount,
      ease: "power4.out", 
    });
  }

  return timeline;
}
